import { BaseException } from 'exceptions/baseException';

export class ConflictException extends BaseException {
  static status = 409;

  constructor(message?: string) {
    super(message, ConflictException.status);
  }
}
